<script>
import { Line } from 'vue-chartjs';
import { scale, alpha } from '../../utils/colors';

export default {
  extends: Line,
  props: {
    title: {
      type: String,
      default: '',
    },
    labels: {
      type: Array,
      default: () => [],
    },
    data: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    const colors = alpha(scale(this.data.length), 0.6);
    const chartdata = {
      datasets: this.data.map((e, i) => {
        let data = this.labels.map(() => 0);
        e.data.map(obj => (data[this.labels.indexOf(obj.label)] = obj.value));

        return {
          label: e.label,
          data,
          backgroundColor: colors[i],
          fill: true,
        };
      }),

      // These labels appear in the legend and in the tooltips when hovering different arcs
      labels: this.labels,
    };

    const options = {
      title: {
        display: true,
        text: this.title,
      },
      maintainAspectRatio: false,
    };
    this.renderChart(chartdata, options);
  },
};
</script>
